<div class="cvds-field-array">
  <div class="card cv-card__main shadow-sm">
    <div class="card-header">{{title}}</div>
    <div class="card-body">
      <div class="row">
        <div class="col-sm-6" *ngFor="let item of items">
    
          <div class="card">
            <div class="card-body">
  
              <div *ngFor="let field of fields">
                <div class="row" *ngIf="item[field.fieldName]">
                  <div class="col-sm-6">
                    {{field.label}}
                  </div>
                  <div class="col-sm-6">
                    <cv-cvds-field
                      [field]="item[field.fieldName]"
                      [showLabel]="false"
                    ></cv-cvds-field>
                  </div>
                </div>
              </div>
              
              <cv-cvds-photos 
                *ngIf="item.cv_photos?.length"
                [photos]="item.cv_photos"
                [width100]="true"
              ></cv-cvds-photos>
    
            </div>
          </div>
    
        </div>
      </div>
    </div>
  </div>
</div>